import { Component, OnInit } from "@angular/core";
import { AcceptanceApproverService } from "../../service/acceptance-approver.service";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { FlashMessagesService } from "angular2-flash-messages";
// import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-acceptance-approver",
  templateUrl: "./acceptance-approver.component.html",
  styleUrls: ["./acceptance-approver.component.scss"],
  providers: [AcceptanceApproverService],
})
export class AcceptanceApproverComponent implements OnInit {
  constructor(
    private acceptanceApproverService: AcceptanceApproverService,
    private fb: FormBuilder,
    private flashMessagesService: FlashMessagesService,
    // private router: Router,
    // private route: ActivatedRoute
  ) {
    this.proposalFluxForm = this.fb.group({
      Nivel: ["", Validators.required],
      Perfil: ["", Validators.required],
      ValorDe: ["", Validators.required],
      ValorAte: ["", Validators.required],
    });
  }

  private profileList = [];
  private proposalFluxForm: FormGroup;
  private levelEditForm: FormGroup;

  private approverList = [];

  private levelToEdit;

  private selectedSegmentID = null;
  private segments = [];

  ngOnInit() {
    this.getProfile();
    this.getSegments();
  }

  getProfile() {
    this.acceptanceApproverService.getProfile().subscribe((result) => {
      this.profileList = result.Result;
      console.log(this.profileList);
    });
  }

  getApprovers() {
    this.levelToEdit = null;
    this.acceptanceApproverService
      .getApprovers(this.selectedSegmentID)
      .subscribe((result) => {
        if (result.Result) {
          this.approverList = result.Result;
          if (this.approverList.length > 0) {
            console.log("Result1", result);
            // Set Nivel initial value
            const nivel =
              this.approverList[this.approverList.length - 1].Nivel + 1;
            this.proposalFluxForm.controls.Nivel.setValue(nivel);
            // Set ValorAté initial value
            const valorDe = +(
              this.approverList[this.approverList.length - 1].ValorAte + 0.01
            ).toFixed(2);
            this.proposalFluxForm.controls.ValorDe.setValue(valorDe);
            //Include the Validator of ValorAte
            const minValorAte = +(
              this.proposalFluxForm.controls.ValorDe.value + 0.01
            ).toFixed(2);
            this.proposalFluxForm.controls.ValorAte.setValidators([
              Validators.min(minValorAte),
              Validators.required,
            ]);
          } else {
            console.log("Result2", result);
            this.proposalFluxForm.controls.Nivel.setValue(1);
            this.proposalFluxForm.controls.ValorDe.setValue(0);
            //Include the Validator of ValorAte
            this.proposalFluxForm.controls.ValorAte.setValidators([
              Validators.min(0.01),
              Validators.required,
            ]);
          }
        }
      });
  }

  segmentChanged(segmentID) {
    this.selectedSegmentID = segmentID;
    this.getApprovers();
    this.proposalFluxForm.controls.Perfil.reset();
    this.proposalFluxForm.controls.ValorAte.reset();
  }

  getSegments() {
    this.acceptanceApproverService.getSegments().subscribe(
      (result) => {
        this.segments = result.Result;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  addLevel() {
    const saveObj = {
      SegmentoID: this.selectedSegmentID,
      Nivel: this.proposalFluxForm.controls.Nivel.value,
      PerfilID: this.proposalFluxForm.controls.Perfil.value,
      ValorDe: this.proposalFluxForm.controls.ValorDe.value,
      ValorAte: this.proposalFluxForm.controls.ValorAte.value,
    };

    console.log("OBJ to Save", saveObj);

    this.acceptanceApproverService.insertApprover(saveObj).subscribe(
      (result) => {
        if (result.Success) {
          this.flashMessagesService.show("Nível cadastrado com sucesso.", {
            cssClass: "alert-success",
            timeout: 6000,
          });
          this.segmentChanged(this.selectedSegmentID);
          this.proposalFluxForm.controls.ValorAte.reset();
          this.proposalFluxForm.controls.Perfil.reset();
        } else {
          console.log("Something wrong here, bro!", result);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  // inactivateLastNivel() {
  //   const lastLimitID = this.approverList[this.approverList.length - 1].ID;
  //   this.acceptanceApproverService.removeApprover(lastLimitID).subscribe(
  //     (result) => {
  //       if (result.Success) {
  //         this.flashMessagesService.show(
  //           "Limite de crédito excluído com sucesso.",
  //           { cssClass: "alert-success", timeout: 6000 }
  //         );
  //         this.getApprovers();
  //         this.proposalFluxForm.controls.ValorAte.reset();
  //         this.proposalFluxForm.controls.Perfil.reset();
  //       } else {
  //         this.flashMessagesService.show(result.Errors, {
  //           cssClass: "alert-danger",
  //           timeout: 6000,
  //         });
  //       }
  //     },
  //     (error) => {
  //       console.log(error);
  //     }
  //   );
  // }

  editNivel(index) {
    console.log(index);
    this.levelToEdit = this.approverList[index];
    this.levelEditForm = this.fb.group({
      Nivel: [this.levelToEdit.Nivel, Validators.required],
      Perfil: [this.levelToEdit.PerfilID, Validators.required],
      ValorDe: [this.levelToEdit.ValorDe, Validators.required],
      ValorAte: [this.levelToEdit.ValorAte, Validators.required],
    });
    //Include the Validator of ValorAte
    const minValorAte = +(
      this.levelEditForm.controls.ValorDe.value + 0.01
    ).toFixed(2);
    this.levelEditForm.controls.ValorAte.setValidators([
      Validators.min(minValorAte),
      Validators.required,
    ]);
  }

  onEditNivel() {
    //If its the last only updates itself
    if (
      this.levelToEdit.Nivel ==
      this.approverList[this.approverList.length - 1].Nivel
    ) {
      const updateObj = {
        Nivel: this.levelToEdit.Nivel,
        ID: this.levelToEdit.ID,
        PerfilID: this.levelEditForm.controls.Perfil.value,
        ValorDe: this.levelToEdit.ValorDe,
        ValorAte: this.levelEditForm.controls.ValorAte.value,
        Ativo: true,
      };
      this.updateNivel(updateObj, true);

      // If not mount the first update object...
    } else {
      let updateObj = {
        Nivel: this.levelToEdit.Nivel,
        ID: this.levelToEdit.ID,
        PerfilID: this.levelEditForm.controls.Perfil.value,
        ValorDe: this.levelToEdit.ValorDe,
        ValorAte: this.levelEditForm.controls.ValorAte.value,
        Ativo: true,
      };
      //then calculate changes
      const baseChange = +(
        this.levelEditForm.controls.ValorAte.value - this.levelToEdit.ValorAte
      ).toFixed(2);

      //then test if changes where made
      if (baseChange != 0) {
        this.updateNivel(updateObj, false); //if changed update the first then loop
        for (
          var i = this.levelToEdit.Nivel;
          i < this.approverList.length;
          i++
        ) {
          updateObj = {
            Nivel: this.approverList[i].Nivel,
            ID: this.approverList[i].ID,
            PerfilID: this.approverList[i].PerfilID,
            ValorDe: +(this.approverList[i].ValorDe + baseChange).toFixed(2),
            ValorAte: +(this.approverList[i].ValorAte + baseChange).toFixed(2),
            Ativo: true,
          };
          const isLast = i == this.approverList.length - 1 ? true : false;
          this.updateNivel(updateObj, isLast); // update each changed level and test if its the last.
        }
      } else {
        //if not change just the first one
        this.updateNivel(updateObj, true);
      }
    }
  }

  //Receives an object to update and a boolean if its the last update of a list (true if its the only one);
  updateNivel(updateObj, isLast) {
    this.acceptanceApproverService.updateApprover(updateObj).subscribe(
      (result) => {
        if (result.Success) {
          this.flashMessagesService.show("Nível Editado com sucesso.", {
            cssClass: "alert-success",
            timeout: 6000,
          });
          if (isLast == true) {
            this.levelToEdit = null;
            this.proposalFluxForm.controls.ValorAte.reset();
            this.proposalFluxForm.controls.Perfil.reset();
            this.getApprovers();
          }
        } else {
          this.flashMessagesService.show(result.Errors, {
            cssClass: "alert-danger",
            timeout: 6000,
          });
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/acceptance-approver/component/acceptance-approver/acceptance-approver.component.ts